import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Alert, AlertColor, Snackbar } from "@mui/material";
import { Eye, EyeOff, Lock, Mail, Shield } from "lucide-react";
import leftPanelImageAsset from "../assets/pic-banner1.jpg";

const winrichLogo = "/lg.png";
const desktopBgImage = leftPanelImageAsset;
const leftPanelImage = leftPanelImageAsset;

interface FormData {
  email: string;
  password: string;
}

interface FormErrors {
  email?: string;
  password?: string;
}

interface SnackbarState {
  open: boolean;
  message: string;
  severity: AlertColor;
}

// Static credentials for different admin roles
const STATIC_CREDENTIALS = {
  'motheradmin@wwtitans.com': { 
    password: 'MotherAdmin@2024!', 
    role: 'MotherAdmin',
    firstName: 'Mother',
    lastName: 'Admin'
  },
  'admin@wwtitans.com': { 
    password: 'Admin@2024!', 
    role: 'Admin',
    firstName: 'Main',
    lastName: 'Admin'
  }
};

const LoginPage = () => {
  const [formData, setFormData] = useState<FormData>({ email: "", password: "" });
  const [errors, setErrors] = useState<FormErrors>({});
  const [snackbar, setSnackbar] = useState<SnackbarState>({ severity: "success", message: "", open: false });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({ ...prevFormData, [name]: value }));
    // Clear errors when user starts typing
    if (errors[name as keyof FormErrors]) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const validateForm = (): boolean => {
    let valid = true;
    let errors: FormErrors = {};

    if (!formData.email) {
      valid = false;
      errors.email = "Email or username is required";
    } else if (formData.email.includes('@') && !/\S+@\S+\.\S+/.test(formData.email)) {
      // Only validate email format if the input contains @ symbol
      valid = false;
      errors.email = "Please enter a valid email";
    }
    
    if (!formData.password) {
      valid = false;
      errors.password = "Password is required";
    } else if (formData.password.length < 6) {
      valid = false;
      errors.password = "Password must be at least 6 characters";
    }

    setErrors(errors);
    return valid;
  };

  const handleCloseSnackbar = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  // const loginClick = async () => {
  //   if (!validateForm()) {
  //     return;
  //   }

  //   setLoading(true);
    
  //   try {
  //     // Simulate API delay
  //     await new Promise(resolve => setTimeout(resolve, 1000));
      
  //     const loginIdentifier = formData.email.trim().toLowerCase();

  //     // Check static credentials first (case-insensitive)
  //     const staticCredentials = STATIC_CREDENTIALS[loginIdentifier as keyof typeof STATIC_CREDENTIALS];
      
  //     if (staticCredentials && staticCredentials.password === formData.password) {
        
  //       // Store authentication data for static credentials
  //       localStorage.setItem('token', 'authenticated');
  //       localStorage.setItem('userRole', staticCredentials.role);
  //       localStorage.setItem('userEmail', formData.email); // Keep original casing for display
  //       localStorage.setItem('userName', `${staticCredentials.firstName} ${staticCredentials.lastName}`);
        
  //       setSnackbar({ 
  //         severity: "success", 
  //         message: `Welcome ${staticCredentials.firstName}! Login successful.`, 
  //         open: true 
  //       });
        
  //       // Navigate immediately after successful login
  //       navigate('/admin-management', { replace: true });
  //       return;
  //     }
      
  //     // Check created admin users from localStorage (only if it exists and has data)
  //     const storedAdmins = localStorage.getItem('adminUsers');
      
  //     if (storedAdmins && storedAdmins.trim() !== '') {
  //       try {
  //         const adminUsers = JSON.parse(storedAdmins);
  //         if (Array.isArray(adminUsers) && adminUsers.length > 0) {
  //           const foundUser = adminUsers.find((user: any) => 
  //             ((user.email && user.email.toLowerCase() === loginIdentifier) || 
  //              (user.username && user.username.toLowerCase() === loginIdentifier)) && 
  //             user.password === formData.password &&
  //             user.status === 'active' &&
  //             user.role !== 'User' // Exclude User role from login
  //           );
            
  //           if (foundUser) {
  //             // Store authentication data for created users
  //             localStorage.setItem('token', 'authenticated');
  //             localStorage.setItem('userRole', foundUser.role);
  //             localStorage.setItem('userEmail', foundUser.email || foundUser.username);
  //             localStorage.setItem('userName', `${foundUser.firstName || ''} ${foundUser.lastName || ''}`.trim() || foundUser.username);
  //             localStorage.setItem('currentUserId', foundUser.id);
              
  //             setSnackbar({ 
  //               severity: "success", 
  //               message: `Welcome ${foundUser.firstName || foundUser.username}! Login successful.`, 
  //               open: true 
  //             });
              
  //             // Navigate immediately after successful login
  //             navigate('/admin-management', { replace: true });
  //             return;
  //           }
  //         }
  //       } catch (parseError) {
  //         console.error('Error parsing stored admin users:', parseError);
  //       }
  //     }
      
  //     // Check if user tried to login with User role (only if storedAdmins exists)
  //     if (storedAdmins && storedAdmins.trim() !== '') {
  //       try {
  //         const adminUsers = JSON.parse(storedAdmins);
  //         if (Array.isArray(adminUsers) && adminUsers.length > 0) {
  //           const userRoleAttempt = adminUsers.find((user: any) => 
  //             ((user.email && user.email.toLowerCase() === loginIdentifier) || 
  //              (user.username && user.username.toLowerCase() === loginIdentifier)) && 
  //             user.role === 'User'
  //           );
            
  //           if (userRoleAttempt) {
  //             setSnackbar({ 
  //               severity: "error", 
  //               message: "Access denied. Users are not allowed to access the admin panel.", 
  //               open: true 
  //             });
  //             return;
  //           }
  //         }
  //       } catch (parseError) {
  //         console.error('Error parsing stored admin users for role check:', parseError);
  //       }
  //     }
      
  //     // If no match found
  //     setSnackbar({ 
  //       severity: "error", 
  //       message: "Invalid email/username or password", 
  //       open: true 
  //     });
      
  //   } catch (error: any) {
  //     console.error('Login error:', error);
  //     setSnackbar({ 
  //       severity: "error", 
  //       message: "Something went wrong. Please try again.", 
  //       open: true 
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const loginClick = async () => {
  // 1. basic front-end validation
  if (!validateForm()) return;

  setLoading(true);
  const loginIdentifier = formData.email.trim().toLowerCase();
  const pwd             = formData.password;

  try {
    /* ───────────────────────────────────────────────
       2. Online login (direct fetch — NOT apiFetch, because
       apiFetch redirects to /login on 401 which breaks the
       static-credential fallback below)
       ─────────────────────────────────────────────── */
    const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3005';
    const res = await fetch(`${API_BASE}/api/staff/auth/login`, {
      method : "POST",
      headers: { "Content-Type": "application/json" },
      body   : JSON.stringify({ email: loginIdentifier, password: pwd })
    });

    if (res.ok) {
      const data = await res.json();
      const roleName = data.user?.role?.name;

      if (roleName === "User") {
        setSnackbar({ severity: "error", message: "Users can't access the admin panel.", open: true });
        setLoading(false);
        return;
      }

      // persist auth
      localStorage.setItem("token",        data.token);
      localStorage.setItem("userRole",     roleName);
      localStorage.setItem("userEmail",    data.user.email);
      localStorage.setItem("userName",     data.user.name);
      localStorage.setItem("currentUserId", String(data.user.id));

      setSnackbar({ severity: "success", message: `Welcome ${data.user.name}!`, open: true });
      navigate("/admin-management", { replace: true });
      return;                               // stop here on success
    }
    // res not ok (e.g. 401 wrong creds) — fall through to static credentials
    console.warn("API login failed with status", res.status, "— trying static credentials…");
  } catch (apiErr: any) {
    // network failure — fall through to static credentials
    console.warn("API login failed, trying static credentials…", apiErr);
  }

  /* ───────────────────────────────────────────────
     4. OFFLINE / DEMO fallback – static credentials
     ─────────────────────────────────────────────── */
  const staticCred = STATIC_CREDENTIALS[loginIdentifier as keyof typeof STATIC_CREDENTIALS];
  if (staticCred && staticCred.password === pwd) {
    localStorage.setItem("token",     "static-demo");
    localStorage.setItem("userRole",  staticCred.role);
    localStorage.setItem("userEmail", loginIdentifier);
    localStorage.setItem("userName",  `${staticCred.firstName} ${staticCred.lastName}`);

    setSnackbar({ severity: "success", message: `Welcome ${staticCred.firstName}!`, open: true });
    navigate("/admin-management", { replace: true });
    setLoading(false);
    return;
  }

  /* ───────────────────────────────────────────────
     5. LocalStorage-based “created admins” check
        (your original logic, unchanged)
     ─────────────────────────────────────────────── */
  try {
    const storedAdmins = localStorage.getItem("adminUsers");
    if (storedAdmins) {
      const adminUsers = JSON.parse(storedAdmins);
      const found = adminUsers.find((u: any) =>
        ((u.email   && u.email.toLowerCase()   === loginIdentifier) ||
         (u.username && u.username.toLowerCase() === loginIdentifier)) &&
        u.password === pwd &&
        u.status   === "active" &&
        u.role     !== "User"
      );
      if (found) {
        localStorage.setItem("token",     "local-admin");
        localStorage.setItem("userRole",  found.role);
        localStorage.setItem("userEmail", found.email || found.username);
        localStorage.setItem("userName",  `${found.firstName || ""} ${found.lastName || ""}`.trim() || found.username);
        localStorage.setItem("currentUserId", found.id);

        setSnackbar({ severity: "success", message: `Welcome ${found.firstName || found.username}!`, open: true });
        navigate("/admin-management", { replace: true });
        setLoading(false);
        return;
      }
    }
  } catch (parseErr) {
    console.error("Error parsing local adminUsers:", parseErr);
  }

  /* ───────────────────────────────────────────────
     6. If everything fails
     ─────────────────────────────────────────────── */
  setSnackbar({ severity: "error", message: "Invalid email/username or password", open: true });
  setLoading(false);
};
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    loginClick();
  };

  return (
    <>
      <div
        style={{
          background:
            `linear-gradient(180deg, rgba(8,10,11,0.72) 0%, rgba(8,10,11,0.84) 100%), url(${desktopBgImage}) center/cover no-repeat, #141617`,
          minHeight: '100vh'
        }}
        className='relative flex items-center justify-center overflow-hidden px-4 py-8 md:px-8'
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div style={{ background: 'radial-gradient(circle at center, rgba(0,0,0,0) 0%, rgba(0,0,0,0.46) 78%)' }} className="absolute inset-0" />
        </div>

        <div
          className='relative grid w-full max-w-[780px] overflow-hidden rounded-[10px] border border-[#2b2f30] bg-[#1f2122] shadow-[0_24px_70px_rgba(0,0,0,0.5)] lg:grid-cols-[0.94fr_1.06fr]'
        >
          <div
            className='relative hidden min-h-[420px] overflow-hidden lg:block'
            style={{
              backgroundImage: `linear-gradient(180deg, rgba(10,12,13,0.42) 0%, rgba(10,12,13,0.42) 100%), linear-gradient(90deg, rgba(10,12,13,0.58) 0%, rgba(10,12,13,0.22) 48%, rgba(10,12,13,0.48) 100%), url(${leftPanelImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div className='absolute inset-0'>
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'transparent'
                }}
              />
            
            </div>

            <div className='relative z-10 flex h-full items-center justify-center px-10'>
              <img
                src={winrichLogo}
                alt='bkk07'
                style={{
                  width: 'min(100%, 230px)',
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 10px 28px rgba(0,0,0,0.45))'
                }}
              />
            </div>
          </div>

          <div
            className='relative flex min-h-[auto] items-center justify-center px-5 py-8 sm:px-8 sm:py-10 lg:min-h-[420px] lg:border-l lg:border-[#2b2f30] lg:px-7'
            style={{
              background: '#242526'
            }}
          >
            <div
              style={{
                width: '100%',
                maxWidth: '340px',
                borderRadius: '20px',
                background: 'transparent',
                padding: '6px 4px',
                boxShadow: 'none'
              }}
            >
              <div style={{ marginBottom: '18px' }}>
                <h2 style={{ color: '#f3f4f6', fontSize: '18px', fontWeight: 500, margin: 0 }}>
                  Agent login
                </h2>
              </div>

              <form className='space-y-4' onSubmit={handleSubmit}>
              {/* Email */}
              <div>
               
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Mail className="h-4 w-4" style={{ color: '#4b5563' }} />
                  </div>
                  <input
                    type='text'
                    name='email'
                    id='email'
                    autoComplete='email'
                    required
                    style={{
                      width: '100%',
                      paddingLeft: '38px',
                      paddingRight: '12px',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                      background: '#181b1c',
                      border: `1px solid ${errors.email ? '#ef4444' : '#3a3f40'}`,
                      borderRadius: '14px',
                      color: '#ffffff',
                      fontSize: '13px',
                      outline: 'none',
                      boxSizing: 'border-box',
                    }}
                    placeholder='Enter your email'
                    value={formData.email}
                    onChange={handleChange}
                    onFocus={e => (e.target.style.borderColor = '#25ee89')}
                    onBlur={e => (e.target.style.borderColor = errors.email ? '#ef4444' : '#3a3f40')}
                  />
                </div>
                {errors.email && <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>{errors.email}</p>}
              </div>

              {/* Password */}
              <div>
                
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Lock className="h-4 w-4" style={{ color: '#4b5563' }} />
                  </div>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name='password'
                    id='password'
                    autoComplete='current-password'
                    required
                    style={{
                      width: '100%',
                      paddingLeft: '38px',
                      paddingRight: '44px',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                      background: '#181b1c',
                      border: `1px solid ${errors.password ? '#ef4444' : '#3a3f40'}`,
                      borderRadius: '14px',
                      color: '#ffffff',
                      fontSize: '13px',
                      outline: 'none',
                      boxSizing: 'border-box',
                    }}
                    placeholder='Enter your password'
                    value={formData.password}
                    onChange={handleChange}
                    onFocus={e => (e.target.style.borderColor = '#25ee89')}
                    onBlur={e => (e.target.style.borderColor = errors.password ? '#ef4444' : '#3a3f40')}
                  />
                  <button
                    type="button"
                    style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword
                      ? <EyeOff className="h-4 w-4" style={{ color: '#6b7280' }} />
                      : <Eye className="h-4 w-4" style={{ color: '#6b7280' }} />
                    }
                  </button>
                </div>
                {errors.password && <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>{errors.password}</p>}
              </div>

              {/* Submit Button */}
              <button
                type='submit'
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: loading ? '#4fcf7b' : '#63ea86',
                  border: 'none',
                  borderRadius: '14px',
                  color: '#0c1810',
                  fontWeight: 800,
                  fontSize: '14px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  marginTop: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  boxShadow: 'none',
                  transition: 'all 0.2s ease',
                  opacity: loading ? 0.8 : 1,
                }}
              >
                {loading ? (
                  <>
                    <div style={{ width: '18px', height: '18px', border: '2px solid #000', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                    Signing in...
                  </>
                ) : (
                  'Login'
                )}
              </button>
              </form>

              
            </div>
          </div>

         
        </div>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default LoginPage;
